<template>
    <v-chip-group show-arrows center-active class="mb-40 mb-lg-80">
        <v-chip :to="{ path: '/lectures' }" exact x-large class="justify-center" active-class="primary">
            <span>전체 </span>
        </v-chip>
        <template v-for="item in items">
            <v-chip :key="item._id" :to="{ path: '/lectures', query: { category: item.code } }" exact x-large class="justify-center" :class="{ primary: $route.path == '/lectures' && $route.query.category == item.code }" active-class="primary">
                <span> {{ item.name }} </span>
            </v-chip>
        </template>
        <v-chip :to="{ path: '/lectures', query: { isStream: true } }" exact x-large class="justify-center" active-class="primary">
            <span>실시간 교육</span>
        </v-chip>
        <v-chip :to="{ path: '/lectures', query: { isMiceNow: true } }" exact x-large class="justify-center" active-class="primary">
            <span>MICE Now</span>
        </v-chip>
    </v-chip-group>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("lecture/category", ["items"]),
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-slide-group__wrapper {
        margin: 0 12px;
    }
    .v-slide-group__content {
        justify-content: center;
        .v-chip {
            padding: 0 20px;
            margin: 0 6px 0 0;
            border-radius: 10px;
            height: 44px;
            font-size: 1.4rem;
            font-weight: 500;
            background-color: #f5f5f5;
        }
        .v-chip.primary {
            font-weight: 700;
        }
        .v-chip:last-child {
            margin: 0;
        }
    }
    .v-slide-group__next,
    .v-slide-group__prev {
        flex: 0 1 44px;
        min-width: 44px;
        border-radius: 50%;
        border: 1px solid var(--v-primary-base);
        transition: 0.1s ease-out;
        background-size: 12px 16px;
        background-position: center;
        background-repeat: no-repeat;
    }
    .v-slide-group__next {
        background-image: url(/images/icon/icon-right-arrow-primary.svg);
    }
    .v-slide-group__prev {
        background-image: url(/images/icon/icon-left-arrow-primary.svg);
    }
    .v-slide-group__next--disabled,
    .v-slide-group__prev--disabled {
        opacity: 0.4;
    }
    .v-slide-group__prev i.v-icon.mdi.mdi-chevron-left,
    .v-slide-group__next i.v-icon.mdi.mdi-chevron-right {
        display: none;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep {
        .v-slide-group__content {
            .v-chip {
                min-width: 180px;
            }
        }
    }
}
@media (min-width: 1024px) {
    ::v-deep {
        .v-slide-group__wrapper {
            margin: 0 24px;
        }
        .v-slide-group__content {
            .v-chip {
                min-width: 236px;
                margin: 0 10px 0 0;
                border-radius: 20px;
                height: 56px;
                font-size: 1.8rem;
            }
            .v-chip:last-child {
                margin: 0;
            }
        }
        .v-slide-group__next,
        .v-slide-group__prev {
            flex: 0 1 56px;
            min-width: 56px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
